import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=682d5a28&scoped=true&lang=pug&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=682d5a28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d5a28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682d5a28')) {
      api.createRecord('682d5a28', component.options)
    } else {
      api.reload('682d5a28', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=682d5a28&scoped=true&lang=pug&", function () {
      api.rerender('682d5a28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/Tabs.vue"
export default component.exports